import { BASE_URL, POST_FILE_ACCESS, SYSTEM_ERROR, GET_LOCATION_ID, SOS_BASE_URL, GET_ROLES_ENDPOINT, USERS_PREVILEGE_ENDPOINT, SOMS_API_KEY, GET_STORE_CATALOGUE } from "./CONSTANTS";
import { Get, Post, Put } from "./apiService";

export const getStoreCatalogue = (request) => {
    return new Promise((resolve, reject) => {
        try {
            request.url = `${BASE_URL}${GET_STORE_CATALOGUE}?type=${request.type}&apikey=${request.apikey}`;
            Get(request)
                .then((res) => {
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};

export const getRoles = (request) => {
    return new Promise((resolve, reject) => {
        try {
            request.url = `${BASE_URL}${GET_ROLES_ENDPOINT}?apikey=${SOMS_API_KEY}`;
            Get(request)
                .then((res) => {
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};

export const getUser = (request) => {
    return new Promise((resolve, reject) => {
        try {
            request.url = `${BASE_URL}${USERS_PREVILEGE_ENDPOINT}${request.userId}?apikey=${SOMS_API_KEY}`;

            Get(request)
                .then((res) => {
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};

export const updateUser = (request) => {
    return new Promise((resolve, reject) => {
        try {
            request.url = `${BASE_URL}${USERS_PREVILEGE_ENDPOINT}${request.userId}?apikey=${SOMS_API_KEY}`;

            Put(request)
                .then((res) => {
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};

export const GetLocationIds = (request) => {
    return new Promise((resolve, reject) => {
        try {
            request.url = `${BASE_URL}${GET_LOCATION_ID}`;
            Get(request)
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};

export const postFileAccess = (request) => {
    return new Promise((resolve, reject) => {
        try {
            request.url = `${SOS_BASE_URL}${POST_FILE_ACCESS}?apikey=${request.apikey}`;
            request.config = {
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                }
            }
            Post(request)
                .then((res) => {
                    if (res) {
                        resolve(res.data);
                    }
                })
                .catch((errResponse) => {
                    reject(errResponse);
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};

export const showErrorMessageByCode = err => {
    const { response } = err;

    if (err?.code === "ERR_NETWORK") {
        return {
            errTitle: "No Network Connection",
            errContent: "Unable to connect to the server. Please check your internet connection and try again."
        }
    }

    switch (response?.status) {
        case 400: return {
            errTitle: "400 - Invalid Input",
            errContent: `The data provided is incorrect or improperly formatted. Please review your input
            and ensure that all required fields are filled-out accurately. If you continue to
            experience this issue, please contact our support team for assistance.`
        };
        case 403: return {
            errTitle: "403 - Forbidden",
            errContent: `Access Denied. You do not have the necessary permissions to view or interact with
            this content. If you believe this is in error, please contact our support team for
            assistance.`
        };
        case 404: return {
            errTitle: "404 - Resource not found",
            errContent: "The resource you are looking for was not found."
        }
        case 500: return {
            errTitle: "Something went wrong",
            errContent: `We're sorry, but something went wrong on our end. Please try again later.
            Feel free to contact our support if the problem persists.`
        };
        case 503: return {
            errTitle: "Something went wrong",
            errContent: `Our services are currently undergoing maintenance or experiencing heavy load.
            We apologize for the inconvenience. Please try again later. If the issue persists,
            feel free to contact our support team for updates.`
        }
        default: return {
            errTitle: "Error",
            errContent: `We're sorry, but something went wrong on our end. Please try again later.
            Feel free to contact our support if the problem persists.`
        }
    }
}